<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="card SmallForm rounded">
      <div class="card-header MyCardHeader rounded-top">
        <h2 class="Head">Notification</h2>
      </div>
      <div class="card-body MyCardBody rounded-bottom text-center">
        <p>This page was not found</p>
      </div>
      <div class="form-group col-12 mt-3">
        <button
          class="btn btn-block btn-secondary"
          type="button"
          (click)="goHome()"
        >
          <span> Close </span>
        </button>
      </div>
    </div>
  </div>
</div>
